module.exports = __webpack_public_path__ + "4c8b1fa1875e2b85d9a17cd321e89d74.svg";